import { ViewMode } from "@/components/view-toggle/viewToggle";
import { createSlice } from "@reduxjs/toolkit";

export interface SearchViewModeSliceState {
  viewMode: ViewMode | "";
}

const initialState = {
  viewMode: "",
};

export const searchViewModeSlice = createSlice({
  name: "searchViewModeSlice",
  initialState,
  reducers: {
    setGridMode: (state) => {
      state.viewMode = "grid" as ViewMode;
    },
    setListMode: (state) => {
      state.viewMode = "list";
    },
    setSearchViewMode: (state, action) => {
      if (!action) return;
      if (action.payload === "grid") state.viewMode = "grid";
      if (action.payload === "list") state.viewMode = "list";
      if (action.payload === "") state.viewMode = "";
    },

    resetViewMode: (state) => {
      state.viewMode = "";
    },
  },
});

export const { setGridMode, setListMode, setSearchViewMode, resetViewMode } = searchViewModeSlice.actions;
export default searchViewModeSlice;
